import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Toolbar from "@material-ui/core/Toolbar/Toolbar";
import AppBar from '@material-ui/core/AppBar';
import IconButton from '@material-ui/core/IconButton';
import ArrowBack from '@material-ui/icons/ArrowBack';
import Typography from '@material-ui/core/Typography';
import {connect} from 'react-redux';
import {fetchJobsIfNeeded} from "../state/actions/jobs";
import AddShiftForm from "../parts/PostShiftForm";
import moment from "moment";
import {fetchManagersIfNeeded} from "../state/actions/managers";
import {postShift} from "../state/actions/shifts";
import ShiftDetails from "../parts/ShiftDetails";
import PaymentSummary from "../parts/ShiftPaymentSummary";
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import singleshiftLogo from '../assets/images/singleshift-logomark.png';
import {receiveBusiness} from "../state/actions/business";
import config from "../config";
import WrapWithLoader from "../parts/WrapWithLoader";


class PostShiftModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showReviewShift: false,
      shift: null,
      loading: false,
    }
  }

  componentDidMount() {
    window.analytics.track("Business Dashboard - Opened Create Shift Form", {slug: this.props.business.slug});

    this.props.fetchJobsIfNeeded();
    this.props.fetchManagersIfNeeded(this.props.business);

    this.handler = window.StripeCheckout.configure({
      key: config.stripeKey,
      image: 'https://stripe.com/img/documentation/checkout/marketplace.png',
      locale: 'auto',
      token: this.saveCard
    });
  }

  saveCard = (token) => {
    // You can access the token ID with `token.id`.
    // Get the token ID to your server-side code for use.
    this.setState({
      loading: true
    });
    fetch(`${config.apiRoot}/businesses/${this.props.business.id}/stripe/`, {
      method: 'POST',
      body: JSON.stringify({
        token: token.id,
        email: token.email,
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      this.setState({loading: false});
      window.analytics.track("Business Dashboard - Saved Credit Card");
      response.json().then(business => {
        this.props.receiveBusiness(business);
      })
    }).then(error => {
    });
  };

  openStripeModal = () => {
    // Open Checkout with further options:
    window.analytics.track('Business Dashboard - Clicked Add Payment Method');
    this.setState({loading: true});

    this.handler.open({
      name: 'SingleShift',
      description: 'Making food and beverage life easier.',
      currency: 'sgd',
      panelLabel: 'Save Card',
      email: this.props.user && this.props.user.email,
      image: singleshiftLogo,
      closed: () => {
        window.analytics.track("Business Dashboard - Closed Credit Card Modal");
        this.setState({
          loading: false,
        });
      },
    });
  };

  reviewShift = (values) => {
    const {
      date,
      startTime,
      endTime,
      ...otherValues
    } = values;

    const startTimeMoment = moment(`${date} ${startTime}`);
    const endTimeMoment = moment(`${date} ${endTime}`);
    const start_time = startTimeMoment.toISOString(true);
    const end_time = endTimeMoment.toISOString(true);

    const shift = {
      start_time,
      end_time,
      business: this.props.business.id,
      ...otherValues,
    };

    this.setState({
      showReviewShift: true,
      shift: shift,
    });
  };

  postShift = () => {
    window.analytics.track("Business Dashboard - Created Shift", {slug: this.props.business.slug});
    this.setState({loading: true});
    return this.props.postShift(this.state.shift).then(
      response => {
        this.setState({loading: false});
        this.props.closeCreateShiftModal();
        this.props.createShiftSuccess();
      },
      error => console.log(error),
    );
  };

  clickedBack = () => {
    if (this.state.showReviewShift) {
      this.setState({
        showReviewShift: false,
      })
    } else {
      this.props.closeCreateShiftModal();
    }
  };

  render() {
    const {classes} = this.props;

    return (
      <React.Fragment>
        <AppBar position={'sticky'} color={'secondary'}>
          <Toolbar>
            <IconButton className={classes.backButton} onClick={this.clickedBack} color="inherit" aria-label="Menu">
              <ArrowBack/>
            </IconButton>
            <Typography variant="title">
              {!this.state.showReviewShift ? "Post Shift" : "Review Shift"}
            </Typography>
          </Toolbar>
        </AppBar>
        <div className={classes.content}>
          {(!this.state.showReviewShift) ? (
            <AddShiftForm managers={this.props.managers}
                          jobs={this.props.jobs}
                          onSubmit={this.reviewShift}
            />
          ) : (
            <React.Fragment>
              <ShiftDetails shift={this.state.shift}/>
              <PaymentSummary shift={this.state.shift}/>
              {this.props.business.stripe_id ? (
                <WrapWithLoader loading={this.state.loading}>
                  <Button className={classes.submit}
                          onClick={this.postShift}
                          disabled={this.state.loading}
                          variant="raised" color="primary" type='submit'>
                    Post Shift
                  </Button>
                </WrapWithLoader>
              ) : (
                <WrapWithLoader loading={this.state.loading}>
                  <Button className={classes.submit}
                          onClick={this.openStripeModal}
                          disabled={this.state.loading}
                          variant="raised" color="primary" type='submit'>
                    Add Payment Method
                  </Button>
                </WrapWithLoader>
              )}
            </React.Fragment>
          )}
        </div>
      </React.Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  jobs: state.jobs.items,
  managers: state.managers.items,
  business: state.business.item,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  fetchJobsIfNeeded: () => dispatch(fetchJobsIfNeeded()),
  fetchManagersIfNeeded: (business) => dispatch(fetchManagersIfNeeded(business)),
  postShift: (shift) => dispatch(postShift(shift)),
  receiveBusiness: (business) => dispatch(receiveBusiness(business)),
});

const styles = (theme) => ({
  content: {
    padding: theme.spacing.unit * 3,
    textAlign: 'left',
  },
  backButton: {
    marginRight: theme.spacing.unit * 3,
  },
});


export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(PostShiftModal));



// WEBPACK FOOTER //
// ./src/modals/PostShiftModal.js